module.exports = __webpack_public_path__ + "media/images/flags/32/United-States-bd57ee6bcb33e14e32ab2d89fba31a3f.png";